import React from 'react'
import PropTypes from 'prop-types'

export class ThirdParty extends React.Component {
  componentDidMount() {
    const { children } = this.props
    const script = document.createElement('script')

    script.innerHTML = children
    script.async = true

    document.body.appendChild(script)
  }

  render() {
    return null
  }
}

ThirdParty.propTypes = {
  children: PropTypes.string.isRequired
}

export default ThirdParty
